import React from 'react'
import { DialogTitle, DialogTitleProps } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import { ReactComponent as CloseIcon } from '../../assets/v3/icons/close.svg'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'

interface IYumDialogTitle extends DialogTitleProps {
  handleClose?: () => void
}

const YumDialogTitle = withStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      padding: '24px',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  }),
)(({ children, classes, handleClose, ...props }: IYumDialogTitle) => {
  return (
    <DialogTitle disableTypography classes={classes} {...props}>
      <Typography variant="h6">{children}</Typography>
      {handleClose && <CloseIcon style={{ cursor: 'pointer' }} aria-label="close" onClick={handleClose} />}
    </DialogTitle>
  )
})

export default YumDialogTitle
